export const quotes = [

    {quote: 'We may make contact with ambitious species on other planets or stars; soon thereafter there will be interplanetary war. Then, and only then, we will of this earth be one', author: 'Will Durant'},

    {quote: 'We are punished by our sins, not for them', author: 'Elbert Hubbard'},
    {quote: 'If you\'ve never vomited from doing a set of barbell curls, then you\'ve never experienced outright hard work', author: 'Arthur Jones'},
    {quote: 'Michael, I did nothing. I did absolutely nothing, and it was everything I thought it could be.', author: 'Peter Gibbons, Office Space'},
    {quote: 'If a law is unjust, a man is not only right to disobey it, he is obliged to do so', author: 'Thomas Jefferson'},
    {quote: 'He suffers more than neccessary, who suffers before it is neccessary', author: 'Seneca'},
    {quote: 'There will come a time when you believe everthing is finished. That will be the beginning', author: 'Louis L\'Amour'},
    {quote: 'Education is not preperation for life, education is life itself', author: 'John Dewey'},
    {
        quote:
            "The Times 03/Jan/2009 Chancellor on brink of second bailout for banks",
        author: "first mined bitcoin block"
    },
    {
        quote:
            "The key question to ask in the meeting is: Are we increasing value or lowering costs? Race to the top or race to the bottom, it's a choice.",
        author: "Seth Godin"
    },
    {
        quote: "Being nice is what stupid people do to hedge their bets.",
        author: "Rick & Morty"
    },
    {
        quote:
            "The factory of the future will have only two employees, a man and a dog.The man will be there to feed the dog.The dog will be there to keep the man from touching the equipment.",
        author:
            "Warren G. Bennis, University of Southern California professor of business administration; adviser to Ronald Reagan and John F. Kennedy"
    },
    {
        quote: "Productivity is for robots",
        author: "Kevin Kelly"
    },
    {
        quote:
            "Everyone thinks of changing the world, but no one thinks of changing himself",
        author: "Leo Tolsky"
    },
    {
        quote: "It's in the valley of failure that we sow our seeds of success",
        author: "James Altucher"
    },

    {
        quote:
            "You can have everyting in life that you want, if you help enough people to get what they want",
        author: "Zig Ziglar"
    },
    {
        quote:
            "It is not the man who has too little that is poor, but the one who hankers after more",
        author: "Seneca, Letters from a Stoic"
    },
    {
        quote:
            "Nothing, to my way of thinking, is a better proof of a well ordered mind than a man's ability to stop just where he is and pass some time in his own company.",
        author: "Seneca"
    },
    {
        quote: "How do you defeat terrorism? Don't be terrorized",
        author: "Salman Rushdie"
    },
    {
        quote:
            "The only wealth which you will keep forever is the wealth you have given away",
        author: "Marcus Aurelius"
    },
    {
        quote:
            "Busyness is not the virtue of the most productive. It is a habit of the overwhelmed, exhausted and inefficient. Besides, it is always a choice.",
        author: "?"
    },
    {
        quote: "Be careful of reading health books, you might die of a misprint",
        author: "Mark Twain"
    },
    {
        quote: "Anger is often what pain looks like when it show itself in public",
        author: "Krista Tippett"
    },
    {
        quote: "Too much is just enough",
        author: "Mark Twain, on whiskey"
    },
    {
        quote: "The best way to make your dreams come true is to wake up",
        author: "Cal Fussman"
    },
    {
        quote: "Silence is golden when you can't think of a good answer",
        author: "Cal Fussman"
    },
    {
        quote: "The sun is always shining someplace",
        author: "Cal Fussman"
    },
    {
        quote: "The more we help others, the more we help ourselves",
        author: "Cal Fussman"
    },
    {
        quote: "What you are thinking about, you are becoming",
        author: "Cal Fussman"
    },
    {
        quote:
            "When you are right, nobody remembers. When you are wrong, nobody forgets",
        author: "Cal Fussman"
    },
    {
        quote: "Do not watch the clock. Do what it does. Keep Going",
        author: "Sam Levenson"
    },

    {
        quote:
            "The best way to build large things is to stitch small things together.",
        author: "Facebook"
    },
    {
        quote:
            "People look to time in expectation that it will eventually make them happy, but you cannot find true hapiness by looking toward the future",
        author: "Eckhart Tolle"
    },
    {
        quote:
            "We don't rise to the level of our expectations, we fall to the level of our training.",
        author: "Archilochos"
    },
    {
        quote:
            "Imagine a world in which generations of human beings come to believe that certain films were made by God or that specific software was coded by him. Imagine a future in which millions of our descendants murder each other over rival interpretations of Star Wars or Windows 98. Could anything --anything-- be more rediculous? And yet, this would be no more ridiculous than the world we are living in",
        author: "Sam Harris"
    },
    {
        quote: "As to the Adjective: when in doubt, strike it out",
        author: "Mark Twain"
    },
    {
        quote:
            "There is nothing either good or bad except that thinking makes it so",
        author: "William Shakespeare"
    },
    {
        quote: "The lessons we remember are the lessons we learn the hard way",
        author: "Seth Godin"
    },
    {
        quote:
            "Consider it: every person you have ever met, every person will suffer the loss of his friends and family. All are going to lose everything they love in this world. Why would one want to be anything but kind to them in the meantime?",
        author: "Sam Harris"
    },
    {
        quote: "Anything worth doing is worth doing slowly",
        author: "Mae West"
    },
    {
        quote:
            "People often say that motivation doesn’t last. Well, neither does bathing.  That’s why we recommend it daily.",
        author: "Zig Ziglar"
    },
    {
        quote:
            "The best time to plant a tree was 20 years ago. The second best time is now.",
        author: "Chinese Proverb"
    },
    {
        quote: "Strive not to be a success, but rather to be of value.",
        author: "Albert Einstein"
    },

    {
        quote:
            "I am not a product of my circumstances. I am a product of my decisions.",
        author: "Stephen Covey"
    },
    {
        quote: "Winning is not everything, but wanting to win is.",
        author: "Vince Lombardi"
    },
    {
        quote:
            "The things you own end up owning you. It is only after you lose everything that you are free to do anything.",
        author: "Chuck Palahniuk"
    },
    {
        quote:
            "Great minds discuss ideas; average minds discuss events; small minds discuss people",
        author: "Elanor Roosevelt"
    },
    {
        quote: "Service to others is the rent you pay for your room here on earth.",
        author: "Muhammad Ali"
    },
    {
        quote:
            "Compound interest is the eighth wonder of the world. He who understands it, earns it ... he who doesn't ... pays it.",
        author: "Albert Einstein"
    },
    {
        quote:
            "Tell me and I'll forget, show me and I may remember, involve me and I'll understand",
        author: "Chinese Proverb"
    },
    {
        quote:
            "Nobody can give you freedom. Nobody can give you equality or justice or anything. If you're a man, you take it",
        author: "Malcolm X"
    },
    {
        quote:
            "A man is rich in proportion to the number of things he can afford to let alone",
        author: "Henry David Theroux"
    },
    {
        quote:
            "People who harbor strong convictions without evidence belong at the margins of our societies, not in our halls of power",
        author: "Sam Harris"
    },
    {
        quote:
            "Either God can do nothing to stop catastrophes like this, or he does not care to, or he does not exist. God is either impotent, evil, or imaginary. Take your pick, and choose wisely.",
        author: "Sam Harris"
    },
    {
        quote:
            "What information consumes is rather obvious: it consumes the attention of its recipients. Hence, a wealth of information creates a poverty of attention and a need to allocate that attention efficiently among the overabundance of information sources that might consume it.",
        author: "Herbert Simon"
    },
    {
        quote:
            "Reading, after a certain age, diverts the mind too much from its creative pursuits. Any man who reads too much and uses his own brain too little falls into lazy habits of thinking.",
        author: "Albert Einstein"
    },
    {
        quote: "Love of bustle is not industry.",
        author: "Seneca"
    },
    {
        quote:
            "There are many things of which a wise man might wish to be ignorant.",
        author: "RALPH WALDO EMERSON (1803 1882)"
    },
    {
        quote:
            "Learning to ignore things is one of the great paths to inner peace.",
        author: "Robert J. Sawyer, Calculating God"
    },
    {
        quote:
            "An expert is a person who has made all the mistakes that can be made in a very narrow field.",
        author: "NIELS BOHR, Danish physicist and Nobel Prize winner"
    },
    {
        quote: "Everything popular is wrong.",
        author: "OSCAR WILDE, The Importance of Being Earnest"
    },
    {
        quote:
            "Our wills are simply not of our own making. Thoughts and intentions emerge from background causes of which we are unaware and over which we exert no conscious control. We do not have the freedom we think we have",
        author: "Sam Harris"
    },
    {
        quote:
            "I can't give you a surefire formula for success, but I can give you a formula for failure: try to please everybody all the time.",
        author:
            "HERBERT BAYARD SWOPE, American editor and journalist; first recipient of the Pulitzer Prize"
    },
    {
        quote:
            "Whenever you find yourself on the side of the majority, it is time to pause and reflect.",
        author: "Mark Twain"
    },
    {
        quote: "Reality is merely an illusion, albeit a very persistent one.",
        author: "Albert Einstein"
    },
    {
        quote:
            'These individuals have riches just as we say that we "have a fever", when really the fever has us.',
        author: "SENECA (4 B.C. - 65 A.D.)"
    },
    {
        quote:
            "Meetings are an addictive, highly self indulgent activity that corporations and other organizations habitually engage in only because they cannot actually masturbate.",
        author: "DAVE BARRY, Pulitzer Prize winning American humorist"
    },
    {
        quote:
            "The vision is really about empowering workers, giving them all the information about what's going on so they can do a lot more than they've done in the past.",
        author: "Bill Gates"
    },
    {
        quote:
            "Anyone who lives within their means suffers from a lack of imagination.",
        author: "Oscar  Wilde, Irish dramatist and novelist"
    },
    {
        quote:
            "The reasonable man adapts himself to the world; the unreasonable one persists in trying to adapt the world to himself. Therefore all progress depends on the unreasonable man.",
        author: "George Bernard Shaw"
    },
    {
        quote: "There is no way to happiness -- happiness is the way.",
        author: "Thich Nhat Hanh"
    },
    {
        quote:
            "The simple willingness to improvise is more vital, in the long run, than research.",
        author: "Rolf Potts"
    },
    {
        quote:
            "If you don’t make mistakes, you’re not working on hard enough problems. And that’s a big mistake.",
        author: "Frank Wilczek, 2004 Nobel Prize winner in physics"
    },
    {
        quote:
            "All courses of action are risky, so prudence is not in avoiding danger (it’s impossible), but calculating risk and acting decisively. Make mistakes of ambition and not mistakes of sloth. Develop the strength to do bold things, not the strength to suffer.",
        author: "Niccolo Machiavelli, The Prince"
    }
];


export const backgroundClasses = [

    "warm_flame",
    "night_fade",
    "spring_warmth",
    "juicy_peach",
    "young_passion",
    "lady_lips",
    "sunny_morning",
    "rainy_ashville",
    "frozen_dreams",
    "winter_neva",
    "dusty_grass",
    "tempting_azure",
    "heavy_rain",
    "amy_crisp",
    "mean_fruit",
    "deep_blue",
    "ripe_malinka",
    "cloudy_knoxville",
    "malibu_beach",
    "new_life",
    "true_sunset",
    "morpheus_den",
    "rare_wind",
    "near_moon",
    "wild_apple",
    "saint_petersburg",
    "arielles_smile",
    "plum_plate",
    "everlasting_sky",
    "happy_fisher",
    "blessing",
    "sharpeye_eagle",
    "ladoga_bottom",
    "lemon_gate",
    "itmeo_branding",
    "zeus_miracle",
    "old_hat",
    "star_wine",
    "deep_blue",
    "coup_de_grace",
    "happy_acid",
    "awesome_pine",
    "new_york",
    "shy_rainbow",
    "loon_crest",
    "mixed_hopes",
    "fly_high",
    "strong_bliss",
    "fresh_milk",
    "snow_again",
    "february_ink",
    "kind_steel",
    "soft_grass",
    "grown_early",
    "sharp_blues",
    "shady_water",
    "dirty_beauty",
    "great_whale",
    "teen_notebook",
    "polite_rumors",
    "sweet_period",
    "wide_matrix",
    "soft_cherish",
    "red_salvation",
    "burning_spring",
    "night_party",
    "sky_glider",
    "heaven_peach",
    "purple_division",
    "aqua_splash",
    "above_clouds",
    "spiky_naga",
    "love_kiss",
    "sharp_glass",
    "clean_mirror",
    "premium_dark",
    "cold_evening",
    "cochiti_lake",
    "summer_games",
    "passionate_bed",
    "mountain_rock",
    "desert_hump",
    "jungle_day",
    "phoenix_start",
    "october_silence",
    "faraway_river",
    "alchemist_lab",
    "over_sun",
    "premium_white",
    "mars_party",
    "eternal_constance",
    "japan_blush",
    "smiling_rain",
    "cloudy_apple",
    "big_mango",
    "healthy_water",
    "amour_amour",
    "risky_concrete",
    "strong_stick",
    "vicious_stance",
    "palo_alto",
    "happy_memories",
    "midnight_bloom",
    "crystalline",
    "raccoon_back",
    "party_bliss",
    "confident_cloud",
    "le_cocktail",
    "river_city",
    "frozen_berry",
    "elegance",
    "child_care",
    "flying_lemon",
    "new_retrowave",
    "hidden_jaguar",
    "above_the_sky",
    "nega",
    "dense_water",
    "chemic_aqua",
    "seashore",
    "marble_wall",
    "cheerful_caramel",
    "night_sky",
    "magic_lake",
    "young_grass",
    "colorful_peach",
    "gentle_care",
    "plum_bath",
    "happy_unicorn",
    "full_metal",
    "african_field",
    "solid_stone",
    "orange_juice",
    "glass_water",
    "slick_carbon",
    "north_miracle",
    "fruit_blend",
    "millennium_pine",
    "high_flight",
    "mole_hall",
    "earl_gray",
    "space_shift",
    "forest_inei",
    "royal_garden",
    "rich_metal",
    "juicy_cake",
    "smart_indigo",
    "sand_strike",
    "norse_beauty",
    "aqua_guidance",
    "sun_veggie",
    "sea_lord",
    "black_sea",
    "grass_shampoo",
    "landing_aircraft",
    "witch_dance",
    "sleepless_night",
    "angel_care",
    "crystal_river",
    "soft_lipstick",
    "salt_mountain",
    "perfect_white",
    "fresh_oasis",
    "strict_november",
    "morning_salad",
    "deep_relief",
    "sea_strike",
    "night_call",
    "supreme_sky",
    "light_blue",
    "mind_crawl",
    "lily_meadow",
    "sugar_lollipop",
    "sweet_dessert",
    "magic_ray",
    "teen_party",
    "frozen_heat",
    "gagarin_view",
    "fabled_sunset",
    "perfect_blue",
]



// WEBPACK FOOTER //
// ./src/quotes.js